import { assign, createMachine } from 'xstate';
import { AddonsConfigurationContext, AddConfigurationEvents } from './types';
import { serializeComponents } from './serialize';
import { updateAllocationsList, setError } from './actions';

const initialContext: AddonsConfigurationContext = {
  subscriptionId: null,
  components: [],
  allocations: [],
  allocationsPreview: null,
  error: null,
};

const addOnsConfiguration = createMachine<
  AddonsConfigurationContext,
  AddConfigurationEvents
>(
  {
    id: 'addOnsConfiguration',
    predictableActionArguments: true,
    context: initialContext,
    initial: 'configureAllocationsStep',
    states: {
      configureAllocationsStep: {
        id: 'configureAllocationsStep',
        initial: 'idle',
        states: {
          idle: {
            on: {
              INITIALIZE: {
                target: 'initialize',
                actions: assign((ctx, event) => {
                  return {
                    ...ctx,
                    subscriptionId: event.subscriptionId,
                  };
                }),
              },
            },
          },
          initialize: {
            invoke: {
              src: 'getComponents',
              onDone: {
                target: 'ready',
                actions: assign((ctx, event) => {
                  const serializedComponents = serializeComponents(
                    event.data.items
                  );
                  return {
                    ...ctx,
                    components: serializedComponents,
                  };
                }),
              },
              onError: {
                actions: 'setError',
                target: 'initializationError',
              },
            },
          },
          ready: {
            on: {
              PREVIEW_ALLOCATIONS: {
                target: 'previewAllocations',
                actions: assign((ctx, event) => {
                  return {
                    ...ctx,
                    allocations: event.allocations,
                    error: null,
                  };
                }),
              },
              UPDATE_ALLOCATIONS_LIST: {
                actions: 'updateAllocationsList',
              },
            },
          },
          initializationError: {},
          previewAllocations: {
            invoke: {
              src: 'previewComponentAllocations',
              onDone: {
                target: '#previewAllocationsStep',
                actions: assign((ctx, event) => {
                  return {
                    ...ctx,
                    allocationsPreview: {
                      ...event.data,
                    },
                  };
                }),
              },
              onError: {
                actions: 'setError',
                target: 'ready',
              },
            },
          },
        },
      },
      previewAllocationsStep: {
        id: 'previewAllocationsStep',
        initial: 'idle',
        states: {
          idle: {
            on: {
              UPDATE_ALLOCATIONS: {
                target: 'updateAllocations',
              },
              GO_BACK: {
                target: '#configureAllocationsStep.ready',
              },
            },
          },
          updateAllocations: {
            invoke: {
              src: 'updateComponentAllocations',
              onDone: {
                actions: 'updateSubscriptionBalance',
                target: 'updateSuccess',
              },
              onError: {
                actions: 'setError',
                target: 'error',
              },
            },
          },
          updateSuccess: {
            type: 'final',
          },
          error: {
            on: {
              UPDATE_ALLOCATIONS: {
                target: 'updateAllocations',
              },
              GO_BACK: {
                target: '#configureAllocationsStep.ready',
              },
            },
          },
        },
      },
    },
  },
  {
    actions: {
      updateAllocationsList,
      setError,
    },
  }
);

export { addOnsConfiguration };
